// Middleware
import AuthMiddleware from '@middleware/AuthMiddleware';

// Layouts
import LayoutConsole from '@layouts/LayoutConsole';

// Pages
import PageAccount from '@pages/account';
import PageBilling from '@pages/billing';
import PageCompany from '@pages/company';
import PageMembers from '@pages/members';
import PageMembersEdit from '@pages/members-edit';

export default {
    path: '/',
    component: LayoutConsole,
    meta: {
        middleware: [
            AuthMiddleware,
        ],
    },
    children: [
        {
            path: 'company',
            name: 'company',
            component: PageAccount,
            redirect: {
                name: 'company-settings',
            },
            children: [
                {
                    path: 'settings',
                    name: 'company-settings',
                    component: PageCompany,
                    meta: {
                        title: 'Company | Settings',
                    },
                },
                {
                    path: 'members',
                    name: 'members',
                    component: PageMembers,
                    meta: {
                        title: 'Company | Members',
                    },
                },
                {
                    path: 'members/:member_id',
                    name: 'members-edit',
                    component: PageMembersEdit,
                    meta: {
                        title: 'Company | Edit Member',
                    },
                },
                {
                    path: 'billing',
                    name: 'billing',
                    component: PageBilling,
                    meta: {
                        title: 'Company | Billing',
                    },
                },
            ]
        },
    ]
}